<!--
    Alert mark for the "Site Canceled" label (Figma 4720-17696): an outlined circle
    with an exclamation. currentColor so the label controls the colour — it sits
    white on red today.
-->
<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <circle cx="7" cy="7" r="6.25" stroke="currentColor" stroke-width="1.25" />
        <path d="M7 3.6v4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <circle cx="7" cy="10.1" r="0.75" fill="currentColor" />
    </svg>
</template>
